
			VANTA.DOTS({
				el: "body",
				mouseControls: false,
				touchControls: false,
				gyroControls: false,
				minHeight: 200.0,
				minWidth: 200.0,
				scale: 1.0,
				scaleMobile: 1.0,
				color: 0x991E2A,
				color2: 0x991E2A,
				backgroundColor: 0x0c090d,
				size: 2.0,
				sphereRotation: -0.002,
				meshRotation: 0.004,
			});
		